import React from 'react';

function Input({ label, helper, type = 'text', id, className = '', ...rest }) {
    return (
        <label className={`input-wrapper ${className}`} htmlFor={id}>
            {label && <span className="input-label">{label}</span>}
            <input id={id} type={type} {...rest} />
            {helper && <span className="helper-text">{helper}</span>}
        </label>
    );
}

export default Input;
